/*
 * SPELLROO GAMING — "Clear cart" for the cart drawer and the /cart page.
 * Buttons: [data-sr-cart-clear]. On the cart page add data-context="page" (reloads after clearing).
 * In the drawer it re-renders through Ella's own updateSidebarCart, so counts and
 * the free-shipping bar update the same way as removing a single item.
 */
(function () {
  if (window.srCartClearReady) return;
  window.srCartClearReady = true;

  var root = (window.routes && window.routes.root) || '';
  if (root === '/') root = '';

  function setVisible(count) {
    document.querySelectorAll('[data-sr-cart-clear]').forEach(function (btn) {
      if (btn.dataset.context === 'page') return;
      btn.hidden = !(count > 0);
    });
  }

  document.addEventListener('cart-update', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') setVisible(e.detail.item_count);
  });

  // Any code path that re-renders the drawer (Ella, bundle app, quick shop…) — follow what is actually shown.
  function watchDrawer() {
    var wrap = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (!wrap || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (wrap.classList.contains('is-loading')) return;
      setVisible(wrap.querySelectorAll('.previewCartItem').length);
    }).observe(wrap, { childList: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr-cart-clear]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    if (!window.confirm(btn.dataset.confirm || 'Remove all items from your cart?')) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(root + '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var onCartPage = btn.dataset.context === 'page' || /\/cart\/?$/.test(window.location.pathname);
        if (onCartPage) {
          window.location.reload();
          return;
        }
        if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
          window.sharedFunctions.updateSidebarCart(cart);
        } else {
          window.location.reload();
          return;
        }
        setVisible(0);
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        window.location.reload();
      });
  });
})();
